"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { BlockInspectorProps, InspectorProps } from "../../lib/inspector";
import {
  ImageArrangement,
  type ImageArrangementProps,
} from "./image-arrangement";

export type ImageArrangementInspectorProps = BlockInspectorProps &
  InspectorProps<"image">;

export function ImageArrangementPreview(
  props: Readonly<ImageArrangementProps>
) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  const headlineInspector = useContentfulInspectorMode({
    entryId: props.headline?.sys?.id,
    locale: props.headline?.sys?.locale,
  });

  return (
    <ImageArrangement
      {...props}
      images={props.images.map((item) => ({ ...item, isPreview: true }))}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
        headline: headlineInspector({ fieldId: "headline" }) ?? undefined,
      }}
    />
  );
}
